<template>
    <div class="view scene">
      <div class="container">
        <h1 class="h1">3° Scène</h1>
        <multimedias
          :category="category"
          :categories="categories"
          :multimedias="multimedias"
          :loading="loading"
          @filter="onFilter"
        />
        <p v-if="noMore">Il n'y a plus de médias disponibles.</p>
      </div>
    </div>
</template>

<script>
import Multimedias from '@/components/partials/Multimedias.vue';

export default {
  components: {
    Multimedias
  },
  beforeMount() {
    if (this.$store.state.multimedia.items.length === 0) {
      this.$store.dispatch('multimedia/get');
    }
    if (this.$store.state.multimedia.categories.length === 0) {
      this.$store.dispatch('multimedia/categories');
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  data() {
    return {
      scroll: this.onScroll.bind(this)
    };
  },
  computed: {
    noMore() {
      return this.$store.state.multimedia.noMore;
    },
    multimedias() {
      return this.$store.state.multimedia.items;
    },
    category() {
      return this.$store.state.multimedia.category;
    },
    categories() {
      return this.$store.state.multimedia.categories;
    },
    loading() {
      return this.$store.state.multimedia.requests !== 0;
    },
  },
  methods: {
    onFilter({ event }) {
      this.$store.commit('multimedia/updateCategory', event);
      this.$store.commit('multimedia/updateNoMore', false);
      this.$store.commit('multimedia/setItems', []);
      this.$store.commit('multimedia/updatePage', 1);
      this.$store.dispatch('multimedia/get');
    },
    onScroll() {
      const { scrollY, innerHeight } = window;
      const height = document.body.clientHeight;
      const scroll = scrollY + innerHeight;

      if (scroll >= height - 80) {
        if (!this.loading && !this.noMore) {
          this.$store.dispatch('multimedia/get');
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .scene {
    margin: 0 0 20px;
  }
</style>
